export function getMapBoundsRestriction() {
  return window.google && new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(35, -15),
    new window.google.maps.LatLng(60, 25),
  );
}

export default { getMapBoundsRestriction };
